__turbopack_context__.v({
  "className": "geist_mono_664b44d2-module__YPrIbG__className",
  "variable": "geist_mono_664b44d2-module__YPrIbG__variable",
});
